import { Button, Col, Form, Input, Row, Select, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import servicePath from '../config/apiUrl';
import '../static/css/AddArticle.css';

import { IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css

const { Option } = Select;
const { TextArea } = Input


function MinprogramInfo(props) {

    const [hideSW, setHideSW] = useState(false);
    const [cId, setcId] = useState();
    const [posturl, setPosturl] = useState();
    const [postFile, setPostFile] = useState(null);
    const [fields, setFields] = useState([]);
    // let adid = props.match.params.id
    const [cpId, setCpId] = useState(props.match.params.id)  // 文章的ID，如果是0说明是新增加，如果不是0，说明是修改
    const [adTitle, setAdTitle] = useState('')   //文章标题
    const [about_us, setAbout_us] = useState('')   //文章小标题 描述

    const [typeId, setTypeId] = useState('small') //选择的 小程序信息类型


    // editor 实例
    const [editor, setEditor] = useState(null)   // TS 语法
    // const [editor, setEditor] = useState(null)                   // JS 语法

    // 编辑器内容
    const [richTextContent, setRichTextContent] = useState('<dvi> </dvi>')

    useEffect(() => {
        getMiniProgramInfo()
    }, [])


    // 工具栏配置
    const toolbarConfig: Partial<IToolbarConfig> = {}  // TS 语法
    // const toolbarConfig = { }                        // JS 语法

    // 编辑器配置
    const editorConfig: Partial<IEditorConfig> = {    // TS 语法
        // const editorConfig = {                         // JS 语法
        placeholder: '请输入内容...',
        MENU_CONF: {}

    }
    editorConfig.MENU_CONF['uploadImage'] = {
        server: servicePath.serverUrl + '/admin/uploadImage',
        // fieldName: 'customImg'
        // 继续写其他配置...
        //【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
    }


    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])



    //获取啊小程序详情数据
    const getMiniProgramInfo = () => {
        const hide = message.loading('...');
        axios({
            method: 'get',
            url: servicePath.getMiniProgramInfo,
        }).then(
            res => {
                setTimeout(hide, 100);
                if (res.data.code == 1) {
                    let resData = res.data?.data || {}
                    setRichTextContent(resData.about_us)
                    setCpId(resData.cpId)
                    setFields([

                        {
                            name: ['user', 'title'],
                            value: resData.title,
                        },
                        {
                            name: ['user', 'version_name'],
                            value: resData.version_name,
                        }, {
                            name: ['user', 'contact_email'],
                            value: resData.contact_email,
                        }
                    ])

                } else {
                    console.log("未查到相关的数据:", res.data)
                }


            }
        )

    }



    const validateMessages = {
        required: '${label} 必须填写!',
        types: {
            email: '${label} is not validate email!',
            number: '${label} is not a validate number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };

    const onFinish = values => {
        const key = 'addData';
        let fromData = values.user;
        if (!fromData.version_name) {
            message.error('小程序版描述不能为空')
            return false
        } else if (!fromData.contact_email) {
            message.error('邮箱不能为空')
            return false
        } else if (!fromData.title) {
            message.error('标题不能为空')
            return false
        } else if (!richTextContent) {
            message.error('请填写“关于我们”的详情内容')
            return false
        }

        var formData = new FormData();
        formData.append("cpId", cpId);
        formData.append("version_name", fromData.version_name);
        formData.append("contact_email", fromData.contact_email);
        formData.append("title", fromData.title);
        formData.append("about_us", richTextContent);
        // 保存
        let url = servicePath.editMiniProgramInfo
        let msg = '添加小程序信息信息成功！'
        let errMsg = '添加小程序信息信息失败！'

        if (cpId) {
            msg = '修改小程序信息信息成功！'
            errMsg = '修改小程序信息信息失败！'

        } else {
            formData.append("post_url", postFile);
        }
        message.loading({ content: '保存数据...' });
        axios({
            method: 'POST',
            url: url,
            data: formData,
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    message.success({ content: msg, key, duration: 2 });
                } else {
                    message.error({ content: errMsg, key, duration: 2 });
                }

            }
        ).catch((res) => {
            console.log("err", res)
            message.error({ content: '添加摄像头信息失败2！', key, duration: 2 });
        })
    };


    const layout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 15 },
    };

    return (
        <>
            <Form {...layout} name="nest-messages" fields={fields} onFinish={onFinish} method="post" enctype="multipart/form-data" validateMessages={validateMessages}>
                <div>
                    <Row gutter={12}>
                        <Col span={20}>
                            {cpId && <Form.Item name={['user', 'cpId']} label="小程序信息Id" >
                                <Input autoComplete='off' defaultValue={cpId} maxLength='10' disabled={1} />
                            </Form.Item>}
                            <Form.Item name={['user', 'version_name']} label="小程序版描述" rules={[{ required: true, message: '必填' }]}>
                                <Input autoComplete='off' defaultValue={adTitle} />
                            </Form.Item>
                            <Form.Item name={['user', 'contact_email']} label="联系邮箱" rules={[{ required: true, message: '必填' }]}>
                                <Input autoComplete='off' defaultValue={adTitle} />
                            </Form.Item>
                            <Form.Item name={['user', 'title']} label="标题" rules={[{ required: true, message: '必填' }]}>
                                <Input autoComplete='off' defaultValue={adTitle} />
                            </Form.Item>

                            <Form.Item label="小程序关于ISURF " >
                                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                                    <Toolbar
                                        editor={editor}
                                        defaultConfig={toolbarConfig}
                                        mode="default"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    />
                                    <Editor
                                        defaultConfig={editorConfig}
                                        value={richTextContent}
                                        onCreated={setEditor}
                                        onChange={editor => setRichTextContent(editor.getHtml())}
                                        mode="default"
                                        style={{ height: '500px', overflowY: 'hidden' }}
                                    />
                                </div>
                            </Form.Item>

                        </Col>

                        <Col span={4}>
                            <Row>
                                <Col span={24}>
                                    {cpId && <Button type="primary" size="large" htmlType="submit">修改小程序内容</Button>}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </div>
            </Form>
        </>
    )
}
export default MinprogramInfo